import { Language } from '../indigofair/languages/Language';

export namespace IFaireMetadata {
  /**
   * Return an instance of IFaireMetadata with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IFaireMetadata>): IFaireMetadata =>
    ({
      ...(partial ?? {}),
    } as IFaireMetadata);
}

export interface IFaireMetadata {
  business_name: string | undefined;
  brand_order_token: string | undefined;
  issue_type: string | undefined;
  email: string | undefined;
  first_name: string | undefined;
  last_name: string | undefined;
  platform: string | undefined;
  os_version: string | undefined;
  app_version: string | undefined;
  /**
   * values for ZenDesk dropdowns
   */
  tags: string | undefined;
  /**
   * The language of the chat conversation. Sets the language that Faire Bot replies in and influences how chat tickets
   * are routed to CX agents in Zendesk. This should default to the `userSessionData.userLocaleKey?.language`, but
   * can be updated by FE or mobile depending on the language the user selects for the conversation.
   * We also need to verify that the given `language` is supported for chat, and send English to ZD if it isn't.
   */
  language: keyof typeof Language | undefined;
}
